import memoize from 'memoize-one';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { markAsRead } from 'my-actions/NotificationActions';

export default function useMarkNotificationsRead(type, groupKey) {
  const dispatch = useDispatch();
  const selector = useMemo(
    () =>
      memoize((notifications, type, groupKey) =>
        Object.values(notifications).some(n => !n.read && n.type === type && (!groupKey || n.group_key === groupKey)),
      ),
    [],
  );
  const anyMatching = useSelector(state => selector(state.notifications.items, type, groupKey));
  useEffect(() => {
    if (anyMatching) {
      dispatch(markAsRead(type, groupKey));
    }
  }, [dispatch, type, groupKey, anyMatching]);
}
